import React from 'react';
import styled, { css } from 'styled-components';
import { useDropdown } from '@trevor/ui-components';

export const DropdownItem = styled.div<{ $selected: boolean }>`
  cursor: pointer;
  font-size: 13px;
  line-height: 20px;
  padding: 8px 12px;
  color: #1f2937;

  &:hover {
    background-color: #f7f7f7;
  }

  ${(p) =>
    p.$selected &&
    css`
      background-color: #f7f7f7;
    `}
`;

export type CategoryItemProps = {
  onSelect: F0;
  selected: boolean;
  children: string;
};

export const CategoryItem: React.FC<CategoryItemProps> = ({
  onSelect,
  selected,
  children,
}) => {
  const { toggle } = useDropdown();

  const handleSelect = (e: React.MouseEvent) => {
    e.stopPropagation();
    onSelect();
    toggle();
  };

  return (
    <DropdownItem $selected={selected} onClick={handleSelect}>
      {children}
    </DropdownItem>
  );
};
